import React from 'react'

const YellowStartIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.30005 16.1246C3.91672 16.4246 3.52505 16.4329 3.12505 16.1496C2.72505 15.8663 2.59172 15.4913 2.72505 15.0246L4.15005 10.3996L0.525053 7.82461C0.125053 7.54128 0.00438659 7.16628 0.163053 6.69961C0.321053 6.23294 0.64172 5.99961 1.12505 5.99961H5.60005L7.05005 1.19961C7.13339 0.966276 7.26272 0.786943 7.43805 0.66161C7.61272 0.536943 7.80005 0.474609 8.00005 0.474609C8.20005 0.474609 8.38739 0.536943 8.56205 0.66161C8.73739 0.786943 8.86672 0.966276 8.95005 1.19961L10.4001 5.99961H14.8751C15.3584 5.99961 15.6794 6.23294 15.8381 6.69961C15.9961 7.16628 15.8751 7.54128 15.4751 7.82461L11.8501 10.3996L13.2751 15.0246C13.4084 15.4913 13.2751 15.8663 12.8751 16.1496C12.4751 16.4329 12.0834 16.4246 11.7001 16.1246L8.00005 13.2996L4.30005 16.1246Z"
        fill="#F8F044"
      />
    </svg>
  )
}

export default YellowStartIcon
